export const PAGE_NAME_BRANCH_SALES = {
  SALES_ADVISOR: 'sales advisor',
  LIST_DEALER_TOYOTA: 'list dealer toyota',
  DEALER_TOYOTA: 'dealer toyota',
  DEALER_DETAIL: 'dealer detail',
  CABANG_TOYOTA: 'cabang toyota',
};

export const FEATURE = {
  BRANCH_LISTING_PAGE: 'BRANCH_LISTING_PAGE',
  SALES_LISTING_PAGE: 'SALES_LISTING_PAGE',
  SALES_DETAIL_PAGE: 'SALES_DETAIL_PAGE',
  BRANCH_DETAIL_PAGE: 'BRANCH_DETAIL_PAGE',
};
